import styled from '@emotion/styled'

export const StyledSection = styled.div<{
  direction: 'vertical' | 'horizontal'
}>`
  display: flex;
  flex-direction: ${props => (props.direction === 'horizontal' ? 'row' : 'column')};
`
